import { render, staticRenderFns } from "./HowPremiumWorks.vue?vue&type=template&id=bb1d84d4&scoped=true&"
import script from "./HowPremiumWorks.vue?vue&type=script&lang=ts&"
export * from "./HowPremiumWorks.vue?vue&type=script&lang=ts&"
import style0 from "./HowPremiumWorks.vue?vue&type=style&index=0&id=bb1d84d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1d84d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bb1d84d4', component.options)
    } else {
      api.reload('bb1d84d4', component.options)
    }
    module.hot.accept("./HowPremiumWorks.vue?vue&type=template&id=bb1d84d4&scoped=true&", function () {
      api.rerender('bb1d84d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/HowPremiumWorks.vue"
export default component.exports